import { useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { CloseIcon, DateIcon } from '../../../../../../components/Icon';
import { baseCssBooking } from '../../baseCss';
import { i18n } from '../../../../../../language';
import { classNames } from '../../../../../../utils';
import { KeyboardTimeInput } from '../../../../../../components';
const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '43.75rem',

      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
      backgroundColor: '#fff',
    },
  },
  root: {
    width: '43.75rem',
    maxWidth: '80rem',
    display: 'flex',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    height: '100%',
    overflow: 'auto',
    minWidth: '100%',
    flexDirection: 'column',
    padding: '1.563rem',
  },
  header: {
    justifyContent: 'space-between',
  },
  remarksTitle: {
    fontSize: '1.2rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: '#2e4469',
    lineHeight: '1.5',
  },
  datepicker: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
}));
export default function Accept({ closePopAcceptp, title, open, declineAcceptBsTransferOutRequestApi, date }) {
  const classes = useStyles();
  const baseClasses = baseCssBooking();
  const [data, setData] = useState({
    date: moment(date),
    time: moment(date),
  });
  const onChangeHandle = (type) => (event) => {
    setData((preData) => ({
      ...preData,
      [type]: moment(event),
    }));
  };
  const cancelClick = () => {
    closePopAcceptp();
  };
  const saveClick = () => {
    declineAcceptBsTransferOutRequestApi('accept', { ...data });
  };
  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <Box display="flex" className={classes.header}>
          <Box display="flex" alignItems="baseline">
            <Typography className={baseClasses.headerTitle}>{title}</Typography>
          </Box>
          <IconButton className={baseClasses.closeIcon} onClick={closePopAcceptp} style={{ marginRight: '-10px' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography className={classes.remarksTitle}>{i18n.t('BEDSTATUS_SURE_TRANSFER_IN')}</Typography>
        <Box>
          <div>
            <div className={baseClasses.flexRowMargin} style={{ margin: '1.813rem 0 0.56rem 0' }}>
              <Typography className={baseClasses.labelText}>
                {i18n.t('BEDSTATUS_ADMISSION_DATE_CONFIRMATION')}
              </Typography>
              <Typography className={baseClasses.labelText}>
                {i18n.t('BEDSTATUS_ADMISSION_TIME_CONFIRMATION')}
              </Typography>
            </div>
          </div>
          <div className={baseClasses.flexRowMargin} style={{ margin: '0rem 0 1.5rem 0' }}>
            <Box width="50%">
              <KeyboardDatePicker
                id="bed_transferpop_date"
                autoOk
                variant="inline"
                inputVariant="outlined"
                invalidDateMessage={null}
                format="DD-MM-YYYY"
                value={data.date}
                className={classNames(classes.datepicker, classes.keyboardDatePicker)}
                keyboardIcon={
                  <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                    <DateIcon />
                  </div>
                }
                onChange={onChangeHandle('date')}
                placeholder={i18n.t('BEDSTATUS_TIME')}
              />
            </Box>
            <Box width="50%">
              <KeyboardTimeInput
                id="bed_transferpop_time"
                className={classNames(classes.keyboardTimeInput)}
                value={data.time}
                placeholder={i18n.t('BEDSTATUS_SELECT_TIME')}
                onChange={onChangeHandle('time')}
              />
            </Box>
          </div>
        </Box>
        <div>
          <div className={baseClasses.bottom} style={{ marginTop: '0.5rem' }}>
            <ButtonBase
              id="bed_transferpop_cancel"
              className={baseClasses.bottomDeleteBtn}
              style={{ marginRight: '1.25rem', width: '12.5rem', height: '3rem', flexBasis: 'auto' }}
              onClick={cancelClick}
            >
              {i18n.t('BEDSTATUS_CANCEL')}
            </ButtonBase>
            <ButtonBase
              id="bed_transferpop_save"
              className={baseClasses.bottomSaveBtn}
              onClick={saveClick}
              style={{ marginRight: '1.25rem', width: '12.5rem', height: '3rem', flexBasis: 'auto' }}
            >
              {i18n.t('BEDSTATUS_CONFIRM')}
            </ButtonBase>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
